import { useLanguage } from '../context/LanguageContext';
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <div className="max-w-4xl mx-auto px-4 md:px-6 py-6 md:py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-gray-500 hover:text-[#00aaff] mb-6 transition-colors">
          <ArrowLeft size={18} />
          <span className="text-sm">Retour à l'accueil</span>
        </Link>

        <h1 className="text-3xl md:text-5xl font-black text-gray-900 mb-8">Mentions Légales</h1>

        <div className="prose prose-gray max-w-none space-y-8">
          {/* Éditeur du site */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Éditeur du site</h2>
            <p className="text-gray-700 leading-relaxed">
              Le site <strong>joeycyan.com</strong> est édité par :
            </p>
            <ul className="list-none space-y-2 text-gray-700 ml-0">
              <li><strong>Raison sociale :</strong> Joey Cyan</li>
              <li><strong>Forme juridique :</strong> Société (à préciser selon le statut réel)</li>
              <li><strong>SIRET :</strong> 830 404 588 00014</li>
              <li><strong>Siège social :</strong> 33 Avenue Philippe Auguste, 75011 Paris, France</li>
              <li><strong>Téléphone :</strong> (à compléter)</li>
              <li><strong>Email :</strong> contact@joeycyan.com</li>
              <li><strong>Directeur de la publication :</strong> (Nom du dirigeant à compléter)</li>
            </ul>
          </section>

          {/* Hébergement */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Hébergement</h2>
            <p className="text-gray-700 leading-relaxed">
              Le site est hébergé sur une infrastructure cloud sécurisée.
            </p>
          </section>

          {/* Propriété intellectuelle */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Propriété intellectuelle</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              L'ensemble du contenu de ce site (textes, images, vidéos, logos, graphismes, etc.) est la propriété exclusive de Joey Cyan ou de ses partenaires. Toute reproduction, distribution, modification, adaptation, retransmission ou publication de ces différents éléments est strictement interdite sans l'accord exprès par écrit de Joey Cyan.
            </p>
            <p className="text-gray-700 leading-relaxed">
              La marque <strong>Joey Cyan</strong> ainsi que les logos et visuels associés sont des marques déposées. Toute utilisation non autorisée de ces marques constitue une contrefaçon passible de sanctions civiles et pénales.
            </p>
          </section>

          {/* Données personnelles */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Protection des données personnelles</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Pour exercer ces droits, vous pouvez nous contacter à l'adresse : <strong>contact@joeycyan.com</strong>
            </p>
            <p className="text-gray-700 leading-relaxed">
              Pour plus d'informations, consultez notre <Link to="/politique-confidentialite" className="text-[#00aaff] hover:underline">Politique de Confidentialité</Link>.
            </p>
          </section>

          {/* Cookies */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Cookies</h2>
            <p className="text-gray-700 leading-relaxed">
              Ce site utilise des cookies pour améliorer votre expérience de navigation. Pour en savoir plus, consultez notre <Link to="/politique-cookies" className="text-[#00aaff] hover:underline">Politique de Cookies</Link>.
            </p>
          </section>

          {/* Responsabilité */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Limitation de responsabilité</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Joey Cyan s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, Joey Cyan ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur ce site.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Joey Cyan ne pourra être tenue responsable des dommages directs ou indirects qui pourraient résulter de l'accès au site ou de l'utilisation de celui-ci, y compris l'inaccessibilité, les pertes de données, détériorations, destructions ou virus qui pourraient affecter l'équipement informatique de l'utilisateur.
            </p>
          </section>

          {/* Droit applicable */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Droit applicable et juridiction</h2>
            <p className="text-gray-700 leading-relaxed">
              Les présentes mentions légales sont régies par le droit français. En cas de litige et à défaut d'accord amiable, le litige sera porté devant les tribunaux français compétents.
            </p>
          </section>

          {/* Contact */}
          <section className="bg-gray-50 p-6 rounded-xl">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact</h2>
            <p className="text-gray-700 leading-relaxed">
              Pour toute question concernant les mentions légales, vous pouvez nous contacter :
            </p>
            <ul className="list-none space-y-2 text-gray-700 ml-0 mt-4">
              <li><strong>Email :</strong> contact@joeycyan.com</li>
              <li><strong>Adresse :</strong> 33 Avenue Philippe Auguste, 75011 Paris</li>
            </ul>
          </section>
        </div>

        <p className="text-sm text-gray-400 mt-12">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>
      </div>
    </div>
  );
}
